import { Flex, useColorModeValue } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const RatesPage = ({ children }: Props) => {
  const bgColor = useColorModeValue('white', 'gray.800');

  return (
    <Flex bgColor={bgColor} w="full" h="100vh" overflow="hidden" direction="row">
      {children}
    </Flex>
  );
};
